import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Draggable, {DraggableCore} from 'react-draggable';
//import { updateNumberRight, updateNumberWrong, fetchNumberRight } from '../redux/ActionCreators';
import { connect } from 'react-redux';

/*const mapStateToProps = state => {
  return {
    comboResults: state.comboResults
  }
}

const mapDispatchToProps = dispatch => ({
    updateNumberRight: (numberRight) => { dispatch(updateNumberRight(numberRight))},
    updateNumberWrong: (numberWrong) => { dispatch(updateNumberWrong(numberWrong))}
  });*/

class ChessRowDraggable extends Component {

  constructor(props) {
        super(props);

        this.state = { correctStart: false/*, moveIndex: props.moveIndex*/};

        this.opponentMoves = this.opponentMoves.bind(this);
    }

// todo: is this needed
    eventControl = (event, info) => {

    }

    eventStart = (event, info) => {
      let id = event.target.parentElement.id;
      let rowClicked = id[0];
      let colClicked = id[1];
      let flipBoard = this.props.flipBoard;
      if(flipBoard)
      {
        colClicked = 9 - colClicked;
      }
      let moveIndex = this.props.moveIndex;
      if(this.props.solution[moveIndex] == undefined)
      {
        return;
      }

      if(this.props.solution[moveIndex].startrow == this.props.rowNum && this.props.solution[moveIndex].startcol == colClicked)
      {
        this.setState({
          correctStart: true
        })
      }
      else {
        {
          this.setState({
            correctStart: false
          })
        }
      }
    }

    eventEnd = (event, info) => {
      let flipBoard = this.props.flipBoard;
      let rect = document.getElementById('11').getBoundingClientRect();
      console.log(rect.top)
      if(flipBoard)
      {
        rect = document.getElementById('81').getBoundingClientRect();
      }
      let top = rect.top;
      let left = rect.left;

      let y = event.clientY - top;
      let rowClicked = Math.ceil(y/54);
      let x = event.clientX - left;
      let colClicked = Math.ceil(x/54);

      let moveIndex= this.props.moveIndex;
      let numberRight = this.props.numberRight;
      let numberWrong = this.props.numberWrong;

      if (isNaN(x))
      {
        if(event.changedTouches.length > 0)
        {
          y = event.changedTouches[0].clientY - top;
          rowClicked = Math.ceil(y/54);
          x = event.changedTouches[0].clientX - left;
          colClicked = Math.ceil(x/54);
        }
      }

      if(this.props.solution[moveIndex] == undefined)
      {
        return;
      }

      if(flipBoard)
      {
        colClicked = 9 - colClicked;
        rowClicked = 9 - rowClicked;
      }

      if(this.props.solution[moveIndex].endrow == rowClicked && this.props.solution[moveIndex].endcol == colClicked && this.state.correctStart == true)
      {
        if(moveIndex + 1 == this.props.solution.length)
        {
          numberRight++;
          //this.props.updateNumberRight(numberRight);
          this.props.updateStateCommentFromChild(moveIndex + 1, "You solved it! " + this.props.comments[moveIndex + 1], numberRight, numberWrong);
        }
        else
        {
          numberRight++;
          this.props.updateStateCommentFromChild(moveIndex + 1, "This is correct so far! " + this.props.comments[moveIndex + 1], numberRight, numberWrong);
          setTimeout(this.opponentMoves, 1000);
        }
      }
      else{
        numberWrong++;
        //this.props.updateNumberWrong(numberWrong);
        this.props.updateStateCommentFromChild(moveIndex, "This is not correct. Try again!", numberRight, numberWrong);
      }
    }

    // Fix it so there's no need for empty solution (all equal to -1) for the opponent in the json file

    opponentMoves()
    {
      let numberRight = this.props.numberRight;
      let numberWrong = this.props.numberWrong;

      this.props.updateStateCommentFromChild(this.props.moveIndex + 1, "This is correct so far! " + this.props.comments[this.props.moveIndex + 1], numberRight, numberWrong);
      this.setState({ correctStart: false })
    }


    render() {

      const items = []
      let inNumber = false;
      let currentNumber = 0;
      let position = 0;
      let flipBoard = this.props.flipBoard;

      if(flipBoard)
      {
        position = this.props.pieces.length - 1;
        for (let i = 1; i < 9; i++) {
          let id = this.props.rowNum + i;
          let color = (Number(this.props.rowNum) + i)%2 == 0 ? this.props.squareColor : "white";
          let piece = '';

          if(inNumber == false)
          {
            let currentPiece = this.props.pieces[position];
            if(isNaN(currentPiece))
            {
              if(this.props.pieceType=="solid")
              {
                piece = GetChessPiece(currentPiece);
              }
              else if(this.props.pieceType=="image")
              {
                piece = GetChessImage(currentPiece);
              }
              else
              {
               piece = GetChessUnicode(currentPiece);
              }
            }
            else
            {
               currentNumber = currentPiece;
               if(currentPiece > 1)
               {
                 inNumber = true;
               }
            }
            position--;
          }
          else
          {
            currentNumber--;
            if(currentNumber <= 1)
            {
               inNumber = false;
            }
          }
          if(this.props.pieceType=="solid")
          {
            if(piece == '')
            {
              items.push(<div id = {id} className={color} ></div>)
            }
            else
            {
              items.push(<div id = {id} className={color}><Draggable position={{x: 0, y: 0}} onDrag={this.eventControl} onStart={this.eventStart} onStop={this.eventEnd}><div id = {"Draggable" + id} className="transparent" style={{backgroundImage: 'url("//images.chesscomfiles.com/chess-themes/pieces/classic/150/' + piece + '.png")',backgroundSize: '50px 50px'}}></div></Draggable></div>)
            }
          }
          else if(this.props.pieceType=="image")
          {
            if(piece == '')
            {
              items.push(<div id = {id} className={color} ></div>)
            }
            else
            {
              items.push(<div id = {id} className={color}><Draggable position={{x: 0, y: 0}} onDrag={this.eventControl} onStart={this.eventStart} onStop={this.eventEnd}><div id = {"Draggable" + id} className="transparent" style={{backgroundImage: 'url("/assets/images/' + piece + '.png")',backgroundSize: '50px 50px'}}></div></Draggable></div>)
            }
          }
          else
          {
            items.push(<div id = {id} className={color} >{piece}</div>)
          }
        }
      }
      else {
        for (let i = 1; i < 9; i++) {
          let id = this.props.rowNum + i;
          let color = (Number(this.props.rowNum) + i)%2 == 1 ? this.props.squareColor : "white";
          let piece = '';

          if(inNumber == false)
          {
            let currentPiece = this.props.pieces[position];
            if(isNaN(currentPiece))
            {
              if(this.props.pieceType=="solid")
              {
                piece = GetChessPiece(currentPiece);
              }
              else if(this.props.pieceType=="image")
              {
                piece = GetChessImage(currentPiece);
              }
              else
              {
               piece = GetChessUnicode(currentPiece);
              }
            }
            else
            {
              // todo: is this needed?
               currentNumber = currentPiece;
               if(currentPiece > 1)
               {
                 inNumber = true;
               }
            }
            position++;
          }
          else
          {
            currentNumber--;
            if(currentNumber <= 1)
            {
               inNumber = false;
            }
          }
          if(this.props.pieceType=="solid")
          {
            if(piece == '')
            {
              items.push(<div id = {id} className={color} ></div>)
            }
            else
            {
              items.push(<div id = {id} className={color}><Draggable position={{x: 0, y: 0}} onDrag={this.eventControl} onStart={this.eventStart} onStop={this.eventEnd}><div id = {"Draggable" + id} className="transparent" style={{backgroundImage: 'url("//images.chesscomfiles.com/chess-themes/pieces/classic/150/' + piece + '.png")',backgroundSize: '50px 50px'}}></div></Draggable></div>)
            }
          }
          else if(this.props.pieceType=="image")
          {
            if(piece == '')
            {
              items.push(<div id = {id} className={color} ></div>)
            }
            else
            {
              items.push(<div id = {id} className={color}><Draggable position={{x: 0, y: 0}} onDrag={this.eventControl} onStart={this.eventStart} onStop={this.eventEnd}><div id = {"Draggable" + id} className="transparent" style={{backgroundImage: '/assets/images/' + piece + '.png")',backgroundSize: '50px 50px'}}></div></Draggable></div>)
            }
          }
          else
          {
            items.push(<div id = {id} className={color} >{piece}</div>)
          }
        }
      }

      return (
        <div className="row">
          {items}
        </div>
      )
  }
}

// todo: is this needed?
function GetChessUnicode(cp)
{
  switch (cp) {
  case 'p':
    return "\u265F";
    break;
  case 'P':
    return "\u2659";
    break;
  case 'r':
     return "\u265C";
    break;
  case 'R':
    return "\u2656";
    break;
  case 'n':
    return "\u265E";
    break;
  case 'N':
    return "\u2658";
    break;
  case 'b':
    return "\u265D";
    break;
  case 'B':
    return "\u2657";
    break;
  case 'q':
    return "\u265B";
    break;
  case 'Q':
     return "\u2655";
    break;
  case 'k':
    return "\u265A";
    break;
  case 'K':
    return "\u2654";
    break;
 }
}

 function GetChessPiece(cp)
 {
   switch (cp) {
   case 'p':
     return "bp";
     break;
   case 'P':
     return "wp";
     break;
   case 'r':
      return "br";
     break;
   case 'R':
     return "wr";
     break;
   case 'n':
     return "bn";
     break;
   case 'N':
     return "wn";
     break;
   case 'b':
     return "bb";
     break;
   case 'B':
     return "wb";
     break;
   case 'q':
     return "bq";
     break;
   case 'Q':
      return "wq";
     break;
   case 'k':
     return "bk";
     break;
   case 'K':
     return "wk";
     break;
  }
}

function GetChessImage(cp)
{
  switch (cp) {
  case 'p':
    return "bP";
    break;
  case 'P':
    return "wP";
    break;
  case 'r':
     return "bR";
    break;
  case 'R':
    return "wR";
    break;
  case 'n':
    return "bN";
    break;
  case 'N':
    return "wN";
    break;
  case 'b':
    return "bB";
    break;
  case 'B':
    return "wB";
    break;
  case 'q':
    return "bQ";
    break;
  case 'Q':
     return "wQ";
    break;
  case 'k':
    return "bK";
    break;
  case 'K':
    return "wK";
    break;
 }
}

export default ChessRowDraggable;
//export default connect(mapStateToProps, mapDispatchToProps)(ChessRowDraggable);
